var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33334V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6667 8L11.3333 4.66667ZM2.66668 3.33333H8.00001V2H2.66668C1.93334 2 1.33334 2.6 1.33334 3.33333V12.6667C1.33334 13.4 1.93334 14 2.66668 14H8.00001V12.6667H2.66668V3.33333Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.930a4e3dd7615d89edc077c90e13d704.svg";
export { ForwardRef as ReactComponent };